import React from "react";
import type { Accent } from "../types/configurator";
interface HighlightProps {
  children: React.ReactNode;
  tone?: Accent;
}
export function Highlight({
  children,
  tone = "mint"
}: HighlightProps) {
  return <span className={`inline-block rounded-full px-[0.18em] leading-[1.05] ${tone === "mint" ? "bg-mint" : "bg-rose"}`} data-id="element-100" data-mp="3t36u492lzd5w">
      {children}
    </span>;
}